import { styled } from "@mui/material";

export const IndicatorsCardsGrid = styled("div")`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacing(2)};
  grid-template-columns: repeat(1, minmax(0, 1fr));

  ${({ theme }) => theme.breakpoints.up("sm")} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  ${({ theme }) => theme.breakpoints.up("md")} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  ${({ theme }) => theme.breakpoints.up("lg")} {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
  ${({ theme }) => theme.breakpoints.up("xl")} {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .empty-tags .tags {
    display: none;
  }
  .empty-filter .search-filter {
    display: none;
  }
`;
